import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ServiceEditFormType } from './service-edit-form';
import { ServiceStatusLevel } from 'src/app/base/models/models.swagger.generated';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
  selector: 'app-service-edit-form',
  templateUrl: './service-edit-form.component.html',
  styleUrls: ['./service-edit-form.component.scss'],
  imports: [ReactiveFormsModule, TranslateModule, DropDownListModule]
})
export class ServiceEditFormComponent implements OnInit {
  @Input() serviceEditForm: FormGroup<ServiceEditFormType>;

  public statusOptions: { value: number; text: string }[] = [];
  public dropdownFields = { text: 'text', value: 'value' };

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    this.statusOptions = [
      { value: ServiceStatusLevel.Operational, text: this.translateService.instant('i18n.domain.status.levels.operational') },
      { value: ServiceStatusLevel.Degraded, text: this.translateService.instant('i18n.domain.status.levels.degraded') },
      { value: ServiceStatusLevel.Down, text: this.translateService.instant('i18n.domain.status.levels.down') }
    ];
  }
}
